import { service } from 'services';
import {
  _t, dispatchPendingAction, sleep, basicCRUDAction,
} from 'utils';
import { Notification } from 'models';
import { NOTIFICATION_TYPE, RESOURCE_TYPE, STORAGE_TYPE } from 'constant';
import { getDispatch } from 'redux/store';
import { ACTIONS_TYPES } from '../helper';

const imagesActions = {
  getAll: async () => {
    dispatchPendingAction({ action: ACTIONS_TYPES.IMAGES.GET_ALL });

    const mapImage = (image) => ({
      id: image?.id,
      type: image?.type === RESOURCE_TYPE.SNAPSHOT || (image?.metadata?.createdBy === 'System' ? 'IONOS' : 'UPLOADED'),
      imageType: STORAGE_TYPE.HDD,
      ...image?.properties,
      defaultImage: image?.metadata?.createdBy === 'System',
    });

    const [images = {}, snapshots = {}] = await Promise.all([service.images.getAll(), service.snapshots.getAll()]);
    if (!snapshots.items) snapshots.items = [];
    if (!images.items) images.items = [];

    const dispatch = getDispatch();

    dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        [ACTIONS_TYPES.IMAGES.GET_ALL]: [
          ...snapshots.items.map(mapImage),
          ...images.items.map(mapImage),
        ],
        pendingActions: [],
      },
    });
  },

  getUploadedImages: async () => {
    dispatchPendingAction({
      action: ACTIONS_TYPES.IMAGES.GET_UPLOADED,
    });

    const mapImage = (image) => {
      const {
        id, properties, type: mainType, metadata: { state = '' },
      } = image;

      const typeResult = (
        mainType === RESOURCE_TYPE.SNAPSHOT
          ? RESOURCE_TYPE.SNAPSHOT
          : 'UPLOADED'
      );

      const {
        name,
        size,
        licenceType,
        imageType = STORAGE_TYPE.HDD,
        location,
        cpuHotPlug,
        cpuHotUnplug,
        discVirtioHotPlug,
        discVirtioHotUnplug,
        nicHotPlug,
        nicHotUnplug,
        ramHotPlug,
        ramHotUnplug,
        description = '',
        cloudInit,
      } = properties;

      return {
        id,
        type: typeResult,
        name,
        size,
        licenceType,
        imageType,
        location,
        isSelected: false,
        cpuHotPlug,
        cpuHotUnplug,
        discVirtioHotPlug,
        discVirtioHotUnplug,
        nicHotPlug,
        nicHotUnplug,
        ramHotPlug,
        ramHotUnplug,
        description,
        state,
        cloudInit,
      };
    };

    const [images, snapshots] = await Promise.all([
      service.images.getAll(),
      service.snapshots.getAll(),
    ]);

    const dispatch = getDispatch();
    const { items: snapshotsItems = [] } = snapshots;
    const { items: imagesItems = [] } = images;

    dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        uploadedImages: [
          ...snapshotsItems.map(mapImage),
          ...imagesItems.filter(({ metadata }) => metadata.createdBy !== 'System').map(mapImage),
        ],
        pendingActions: [],
      },
    });
  },

  update: async ({
    id, image, type = 'OWN',
  }) => {
    dispatchPendingAction({
      action: ACTIONS_TYPES.IMAGES.UPDATE,
    });

    let response = null;

    if (type === RESOURCE_TYPE.SNAPSHOT) {
      response = await service.snapshots.update({
        id,
        image,
      });
    } else {
      response = await service.images.update({
        id,
        image,
      });
    }

    const { httpStatus = null } = response;
    const dispatch = getDispatch();

    if (!httpStatus) {
      dispatch({
        type: ACTIONS_TYPES.IMAGES.UPDATE,
        payload: {},
      });

      sleep(1000)
        .then(() => imagesActions.getUploadedImages());
    } else {
      dispatch({
        type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
        payload: {
          notifications: [
            Notification({
              type: NOTIFICATION_TYPE.ERROR,
              action: ACTIONS_TYPES.IMAGES.UPDATE,
              message: _t('Something went wrong!'),
            }),
          ],
          pendingActions: [],
        },
      });
    }
  },

  delete: async ({ type, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.IMAGES.DELETE,
    apiResult: type === RESOURCE_TYPE.SNAPSHOT ? service.snapshots.delete({ id }) : service.images.delete({ id }),
  }),
};

export default imagesActions;
